import { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

import { AUTH_CHANGE_PASSWORD_OK } from '../../constants/auth.strings';
import { accountNoticeClosed, setAccountNoticeListener, type AccountNoticeContent } from '../../services/accountNotice';

// The account message that outlives the page (services/accountNotice.ts). Mounted in BaseLayout, above every guard.
const AccountNotice = () => {
  const [content, setContent] = useState<AccountNoticeContent | null>(null);

  useEffect(() => {
    setAccountNoticeListener(setContent);
    return () => setAccountNoticeListener(null);
  }, []);

  const close = () => {
    setContent(null);
    accountNoticeClosed();
  };

  return (
    <Dialog open={content !== null} onClose={close} aria-labelledby="account-notice-title">
      <DialogTitle id="account-notice-title">{content?.title}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ overflowWrap: 'anywhere' }}>{content?.text}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} autoFocus>
          {AUTH_CHANGE_PASSWORD_OK}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AccountNotice;
